export const getCroppedImg = (
  imageSrc,
  pixelCrop,
  outputWidth,
  outputHeight,
  isCircle = false
) => {
  const image = new Image();
  image.src = imageSrc;

  return new Promise((resolve, reject) => {
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = outputWidth;
      canvas.height = outputHeight;

      // Applies this circle only for profile image
      if (isCircle) {
        const radius = Math.min(outputWidth, outputHeight) / 2;
        ctx.beginPath();
        ctx.arc(
          outputWidth / 2,
          outputHeight / 2,
          radius,
          0,
          2 * Math.PI
        );
        ctx.clip();
      }

      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        outputWidth,
        outputHeight
      );

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }
          resolve(blob);
        },
        "image/jpeg",
        0.9
      );
    };

    image.onerror = () => reject(new Error("Failed to load image"));
  });
};
